import { render, staticRenderFns } from "./ShareIcon.vue?vue&type=template&id=2a638b11&scoped=true&"
import script from "./ShareIcon.vue?vue&type=script&lang=js&"
export * from "./ShareIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShareIcon.vue?vue&type=style&index=0&id=2a638b11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a638b11",
  null
  
)

export default component.exports